<template>
  <div>
    <v-dialog v-model="dialog.form" 
      persistent
      width="450">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 white--text light-green lighten-2">
          Tambah Config TTD
        </v-card-title>
        <v-card-text>
          <v-img
            class="mt-6"
            contain
            width="100%"
            height="350"
            alt="property"
            style="border-radius: 20px;"
            gradient="to top right, rgba(0,0,0,.3), rgba(0,0,0,.3)"
            :src="form.user_signature_image">
            <image-input v-model="images">
              <div slot="activator">
                <v-btn
                  rounded
                  block
                  color="#000"
                  class="text-capitalize white--text"
                  elevation="0"
                  style="position: absolute; bottom: 0px; width: 100%; opacity: 50%;">
                  <v-icon color="white" class="cursor-pointer mr-2">mdi-camera-outline</v-icon> Unggah Gambar
                </v-btn>
              </div>
            </image-input>
          </v-img>
          
          <v-alert 
            class="mt-10"
            type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-card flat min-height="800">
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0':''">
            <v-row>
              <v-col cols="8" class="py-0"></v-col>
              <v-col cols="12" md="4" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-text-field
                  outlined
                  dense
                  :hide-details="true"
                  placeholder="Cari TTD . . ."
                  clearable
                  :color="style.primary"
                  v-model="filter.title"
                  @click:clear="filter.title = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  prepend-inner-icon="mdi-magnify">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"/>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0 py-0':'py-0'" style="min-height: 650px;">
            <v-row class="mt-3">
              <v-col cols="12" md="2"
                v-for="(item, index) in process.run ? 12 : list" 
                :key="index">
                <v-skeleton-loader
                  :loading="process.run"
                  transition="scale-transition"
                  :tile="false"
                  type="card">
                  <div>
                    <v-card class="box-shadow border-radius pa-2"
                      @click="reset(item)">
                      <v-img
                        class="border-radius d-flex align-center justify-center"
                        width="100%"
                        height="200"
                        gradient="to top right, rgba(0,0,0,.3), rgba(0,0,0,.3)"
                        :src="item.user_signature_image">    
                        <div class="d-flex align-center justify-center">
                          <v-icon style="font-size: 50px;" color="white">mdi-camera-outline</v-icon>
                        </div>            
                      </v-img>
                      
                      <v-card-text class="text-center">
                        <p class="mb-0">
                          <span class="body-1 font-weight-bold one-line">
                            {{ item.user_name }}
                          </span>
                        </p>

                        <p class="caption font-weight-bold text-third text-capitalize mb-0">
                          {{ item.user_company_roles_label_name }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-skeleton-loader>
              </v-col>
            </v-row>
            
            <div class="d-flex text-center text--secondary my-16 py-16" style="min-height: 550px;" v-if="!process.run && list.length < 1">
              <v-img 
                class="my-16 py-16"
                contain
                width="200"
                height="200"
                :src="require('@/assets/404/404.svg')">
              </v-img>
            </div>
            <v-divider/>
          </v-card-text>

          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
            <v-row justify="end" align="center" v-if="pagination.total_page > 1">
              <v-col cols="12" md="2" class="d-flex align-center justify-end">
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === 1"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 mr-3"
                  @click="selected.pagination = 1">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>
                <v-btn
                  color="#263238"
                  :disabled="pagination.current < 2"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  @click="selected.pagination = selected.pagination-1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="mx-5" style="width: 75px;">
                  <v-autocomplete
                    v-model="selected.pagination"
                    :items="pagination.detail"
                    color="#263238"
                    auto-select-first
                    outlined
                    dense
                    single-line
                    hide-details
                    hide-selected>
                    <template v-slot:selection="{ item }">
                      {{ item }}
                    </template>
                  </v-autocomplete>
                </div>
                <v-btn
                  color="#263238"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  :disabled="pagination.current >= pagination.total_page"
                  @click="selected.pagination = selected.pagination+1">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === pagination.total_page"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 ml-3"
                  @click="selected.pagination = pagination.total_page">
                  <v-icon>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import ImageInput from "@/components/ImageInput.vue";
  export default {
    data () {
      return {
        selected: {
          pagination: 1
        },
        dialog: {
          form: false,
          delete: false
        },
        filter: {
          title: ''
        },
        images: {
          url: ''
        },
        page: 1,
        list: [],
        pagination: {},
        detail: {},
        form: {
          user_signature_user_id: '',
          user_signature_image: ''
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      ImageInput
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      images: {
        handler: function () {
          if (this.images) {
            this.form.user_signature_image = this.images.url
          }
        },
        deep: true
      },
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 12,
          filter: [
            {
              type: 'string',
              field: 'user_name',
              value: this.filter.title,
              comparison: '<>'
            }
          ]
        }

        await get(`auth/company/signature/list`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      reset(item) {
        this.dialog.form = !this.dialog.form ? true : false

        let id = ''
        if (item !== undefined) {
          id = item.user_signature_user_id === '' ? item.user_id : item.user_signature_user_id
        }

        this.form = { 
          user_signature_user_id: item !== undefined ? id : '',
          user_signature_image: item !== undefined ? item.user_signature_image : ''
        }

        this.images.url = this.form.user_signature_image

        this.process.form = false

        this.error.message = ''
      },
      async save() {
        if (this.form.user_signature_image.length < 1) {
          this.error.message = 'Silahkan masukkan TTD.'
        } else {
          this.error.message = ''
          this.process.form = true

          await post(`auth/company/signature/create`, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.error.message = res.msg
            }
          })
        }
      }
    }
  }
</script>